import api from '@/modules/clinic/api'
import { getCurrentClinic } from '@/utils/localStorageManager'

const getClinics = async ({ commit }) => {
  const clinic = getCurrentClinic()
  commit('setLoadingClinics', true)
  api
    .getClinics(clinic.root_clinic_id || clinic.id)
    .then(({ data }) => commit('setClinics', data))
    .catch(err => console.error('Error fetching clinics:', err))
    .finally(() => commit('setLoadingClinics', false))
}

const setUnity = ({ commit }, unity) => {
  commit('setUnity', unity)
}

const getPatientChatSetting = async ({ commit, state }) => {
  if (state.loadingChatMessageSettings) {
    return
  }
  commit('setLoadingChatMessageSettings', true)
  api
    .getPatientChatSetting()
    .then(({ data }) => {
      commit('setChatMessageSettings', data)
    })
    .catch(err => console.error('Error fetching patient chat setting:', err))
    .finally(() => commit('setLoadingChatMessageSettings', false))
}

const updatePatientChatSetting = async ({ commit }, { id, data }) => {
  commit('setLoadingChatMessageSettings', true)
  api
    .updatePatientChatSetting(id, data)
    .then(({ data }) => commit('setChatMessageSettings', data))
    .catch(err => console.error('Error saving patient chat setting:', err))
    .finally(() => commit('setLoadingChatMessageSettings', false))
}

export default {
  getClinics,
  setUnity,
  getPatientChatSetting,
  updatePatientChatSetting
}
